import React from "react";
import {CGE} from "../../../../common/components/CGE";

const NextStepComercial = ({props}) => {
    
    return (
        <>
            <CGE.FormsField
                horizontal={true}
                labelName="Fecha Ingreso"
                handleChange={({target}) => props.setInputDateAdimission(target.value)}
                idFormElement="inputDateAdimission"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputDateAdimission}
            />
            <CGE.FormsField
                horizontal={true}
                labelName="Estado"
                handleChange={({target}) => props.setInputCondition(target.value)}
                idFormElement="inputCondition"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputCondition}
            />
        </>
    );
};

export default NextStepComercial;